import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { type NowSlotExtended } from '@redteclab/api/clients/bully'

import { useGlobalConfigContext } from '../../../../../global-config'
import { NowTimeLeftCounter } from '../../../../../now'
import { TENANT } from '../../../../../tenant'

export const ProductBuyBoxNowInfoCountdown: FC<{
  nowSlot: NowSlotExtended
}> = ({ nowSlot }) => {
  const { tenant } = useGlobalConfigContext()

  return (
    <span className="mr-1">
      <FormattedMessage
        id="nowCountdown.ifYouBuyInXMinutes"
        values={{
          countdown: (
            <NowTimeLeftCounter
              className={clsx(
                'font-bold',
                tenant === TENANT.COM && 'text-dark-primary-max',
              )}
              nowSlot={nowSlot}
            />
          ),
        }}
      />
    </span>
  )
}
